var _g, _circle, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "56.69px",
    height: "56.69px",
    viewBox: "0 0 56.69 56.69",
    enableBackground: "new 0 0 56.69 56.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 58,
    height: 57,
    xlinkHref: "A1F5A116.png",
    transform: "matrix(1 0 0 1 -1 0)"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -24.6118,
    cy: -72.9116,
    r: 28.0474,
    gradientTransform: "matrix(0.0583 -0.9982 -0.9983 -0.0583 -43.0078 -0.4717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2171,
    style: {
      stopColor: "#BCBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#585858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    style: {
      stopColor: "#191919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8149,
    style: {
      stopColor: "#000000"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    cx: 28.345,
    cy: 28.346,
    r: 28.045
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066AC",
    d: "M53.692,28.347c0,13.999-11.348,25.348-25.347,25.348C14.348,53.695,3,42.346,3,28.347 C3,14.349,14.348,3,28.346,3C42.345,3,53.692,14.349,53.692,28.347"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.983,14.036h-0.972c-8.245,0-10.097,1.25-10.097,8.847h-0.741v-9.588H42.52v9.588h-0.741 c0-7.597-1.853-8.847-10.051-8.847h-1.019v31.126h4.771v0.742H21.213v-0.742h4.771V14.036z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2);
export default __webpack_public_path__ + "static/media/test_2.941e32f630a9b4fa6b02d352c7e0b388.svg";
export { ForwardRef as ReactComponent };